globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.LocalManagement = appCustomerSpace.Modals.LocalManagement || {};

appCustomerSpace.Modals.LocalManagement.AddOnlineService = (function(superClass) {

    utils.extend(AddOnlineService, superClass);

    function AddOnlineService() {
        return AddOnlineService.__super__.constructor.apply(this, arguments);
    }

    $.extend(AddOnlineService.prototype, {
        init: function() {
            var modal = this;

            appCustomerSpace.LimitlessPlugins.Switch.init(this.$html);

            SearchFilter.initFilters(this.$html.find('.input-filter'));

            var $modal = $('.modal');
            var $form = $modal.find('form');

            // Open/Close checkbox
            $form.on('change', '.switchery', function(){
                var $checkbox = $(this),
                    $attributeItemWrapper = $checkbox.closest('.attribute-item-wrapper'),
                    $urlContainer = $attributeItemWrapper.find('.url-container');

                if($checkbox.is(':checked')) {
                    $urlContainer.show();
                    $urlContainer.find('input.input-destroy').val(false);
                } else {
                    $urlContainer.hide();
                    $urlContainer.find('input.input-destroy').val(true);
                }
            });

            $('.add-online-service-btn').on('click', function(e) {
                e.preventDefault();
                $form.find('.input-url').each(function() {
                    if ($(this).val().length == 0) {
                        $(this).closest('.attribute-item-wrapper').find('.input-destroy').val("true");
                    }
                });

                appCustomerSpace.Loader().start({ $container: $form.closest('.modal-content') });

                $form.submit();
                setTimeout(function(){
                    window.location.reload();;
                }, 200)
            });

            return AddOnlineService.__super__.init.apply(this, arguments);
        }
    });

    return AddOnlineService;

})(appCustomerSpace.Modal);
